import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IntakeGroup } from '@/entities/Courses';
import { Svg } from '@/shared/ui/Svg';
import { routerPath } from '@/shared/config/router';
import ArrowRightIcon from '@/shared/assets/icons/arrow-right.svg';
import styles from './IntakeGroupRow.module.scss';

interface IntakeGroupRowProps {
  group: IntakeGroup;
  intakeId: number;
  courseId: number;
}

export const IntakeGroupRow: React.FC<IntakeGroupRowProps> = ({ group, intakeId, courseId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const path = routerPath.groupDetail
      .replace(':courseId', courseId.toString())
      .replace(':intakeId', intakeId.toString())
      .replace(':groupNumber', group.number.toString());
    navigate(path);
  };

  return (
    <tr
      className={styles.groupRow}
      onClick={handleClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleClick();
        }
      }}
      tabIndex={0}
      role="link"
      aria-label={`Open Group ${group.number}`}
    >
      <td className={styles.td}></td>
      <td className={styles.td}>
        <div>
          <span className={styles.groupTitle}>Group {group.number}</span>
        </div>
      </td>
      <td className={styles.td}>
        <span className={styles.groupTitle}>{group.title}</span>
      </td>
      <td className={styles.td}></td>
      <td className={styles.td}></td>
      <td className={styles.td}>
        <div className="flex items-center justify-end">
          <Svg
            Icon={ArrowRightIcon}
            width={20}
            height={20}
            className="cursor-pointer text-[#98A2B3]"
          />
        </div>
      </td>
    </tr>
  );
};
